module.exports = __webpack_public_path__ + "static/media/white_canvas_written.415588e2.png";